import axios from "axios";

const BASE_URL = process.env.VUE_APP_API_URL;
const CLIENT_ID = process.env.VUE_APP_OAUTH_CLIENT_ID;
const CLIENT_SECRET = process.env.VUE_APP_OAUTH_CLIENT_SECRET;
const STORAGE_KEY = "oauth_client";

/**
 * Obtém um token de acesso OAuth via client_credentials grant.
 * Chamado no startup da app e automaticamente pelo interceptor quando o token expira.
 *
 * Usa axios nativo (não a instância customizada) para evitar dependência circular
 * com src/interceptors/axios.js, que importa esta função.
 */
export async function bootstrapClientToken() {
  if (!CLIENT_ID || !CLIENT_SECRET) {
    console.warn("[OAuth] VUE_APP_OAUTH_CLIENT_ID ou VUE_APP_OAUTH_CLIENT_SECRET não configurados.");
    return null;
  }

  const response = await axios.post(
    BASE_URL + "api/oauth/token",
    {
      grant_type: "client_credentials",
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
      scope: "read",
    },
    {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }
  );

  // A resposta do backend é { success, message, data: { access_token, expires_in, ... } }
  const tokenData = response.data?.data ?? response.data;

  const payload = {
    access_token: tokenData.access_token,
    expires_in: tokenData.expires_in,
    obtained_at: Date.now(),
  };

  localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  return payload;
}

/**
 * Retorna o token de cliente armazenado, ou null se não houver.
 */
export function getClientToken() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) return null;
    return JSON.parse(stored);
  } catch {
    return null;
  }
}
